import { render } from "./Costs.vue?vue&type=template&id=61544674"
import script from "./Costs.vue?vue&type=script&lang=ts"
export * from "./Costs.vue?vue&type=script&lang=ts"
script.render = render

export default script